import { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

import AppContext from "../../../context/AppContext";
import MyNavbar from "../../../components/Customer/Mynavbar/MyNavbar";
import Footer from "../../../components/Customer/Footer/Footer";

import "../../../assests/css/customer/OrderResultPage/OrderResultPage.css";

export default function OrderResultPage({ type }) {
  const { baseUrl } = useContext(AppContext);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

    const orderId = searchParams.get("order_id");
  const sessionId = searchParams.get("session_id");
  const [status, setStatus] = useState("loading");
  const [showContent, setShowContent] = useState(false);

  const spawnConfetti = () => {
    const box = document.getElementById("confetti-box");
    if (!box) return;
    const colors = ["#AD8B73","#C4A882","#E8D5C4","#8B6914","#D4A853","#F5E6D3","#7B5EA7","#E8B4B8"];
    const shapes = ["circle","square","rect"];
    for (let i = 0; i < 40; i++) {
      setTimeout(() => {
        const el = document.createElement("div");
        el.className = "confetti-piece";
        const shape = shapes[Math.floor(Math.random() * shapes.length)];
        const size = 6 + Math.random() * 8;
        el.style.cssText = `
          left:${10 + Math.random() * 80}%;top:-12px;
          width:${size}px;height:${shape==="rect"?size*0.4:size}px;
          background:${colors[Math.floor(Math.random()*colors.length)]};
          border-radius:${shape==="circle"?"50%":"2px"};
          animation-duration:${1.4+Math.random()*1.4}s;
          animation-delay:${Math.random()*0.4}s;
        `;
        box.appendChild(el);
        setTimeout(() => el.remove(), 3200);
      }, i * 28);
    }
  };

  useEffect(() => {
    if (!orderId) {
      setStatus(type);
      setTimeout(() => setShowContent(true), 100);
      return;
    }

        const endpoint =
      type === "success"
        ? `/customer/order/success?order_id=${orderId}&session_id=${sessionId}`
        : `/customer/order/cancel?order_id=${orderId}`;

    axios
      .get(`${baseUrl}${endpoint}`)
      .then(() => {
        setStatus(type);
        setTimeout(() => setShowContent(true), 100);
      })
      .catch((error) => {
        console.log(error);
        setStatus(type === "success" ? "error" : "cancel");
        setTimeout(() => setShowContent(true), 100);
      });
  }, [orderId, type, baseUrl]);

  return (
    <>
      <MyNavbar />

      <div className="result-page">
        {status === "loading" && (
          <div className="result-card">
            <div className="spinner"></div>
            <p className="result-sub">Processing your order...</p>
          </div>
        )}

        {status === "success" && (
          <div className={`result-card success-card ${showContent ? "animate-in" : ""}`}>

            {/* Confetti */}
            <div className="confetti-container" id="confetti-box"></div>

            {/* Animated check */}
            <div className="icon-wrap success-icon-wrap">
              <div className="pulse-ring"></div>
              <div className="icon-circle success-circle">
                <svg width="40" height="32" viewBox="0 0 40 32" fill="none">
                  <path
                    className="check-path"
                    d="M4 16L16 27L36 5"
                    stroke="white"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>

            <h1 className="result-title slide-up-1">Order Confirmed!</h1>

            <p className="result-sub slide-up-2">
              Shukriya! Aapka order successfully place ho gaya hai.
            </p>

            {orderId && (
              <div className="order-id-pill slide-up-3">
                <span className="order-id-label">Order ID</span>
                <span className="order-id-value">#{orderId}</span>
              </div>
            )}

            <div className="result-actions slide-up-4">
              <button className="btn-primary" onClick={() => navigate("/")}>
                Continue Shopping
              </button>
            </div>

            <p className="delivery-note slide-up-5">
              Hum jald hi aap tak deliver karenge
            </p>
          </div>
        )}

        {(status === "cancel" || status === "error") && (
          <div className={`result-card cancel-card ${showContent ? "animate-in" : ""}`}>

            <div className="icon-wrap cancel-icon-wrap">
              <div className="icon-circle cancel-circle">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path
                    className="cross-path"
                    d="M8 8L24 24M24 8L8 24"
                    stroke="white"
                    strokeWidth="3.5"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
            </div>

            <h1 className="result-title slide-up-1">Payment Cancelled</h1>

            <p className="result-sub slide-up-2">
              Payment complete nahi hui. Koi baat nahi, dobara try karein.
            </p>

            {orderId && (
              <div className="order-id-pill slide-up-3">
                <span className="order-id-label">Order ID</span>
                <span className="order-id-value">#{orderId}</span>
              </div>
            )}

            <div className="result-actions slide-up-4">
              <button className="btn-primary" onClick={() => navigate("/cart")}>
                Back to Cart
              </button>
              <button className="btn-outline" onClick={() => navigate("/")}>
                Go Home
              </button>
            </div>
          </div>
        )}
      </div>

      <Footer />
    </>
  );
}